module.exports = __webpack_public_path__ + "img/bsidd-6.4db22021.webp";